import './styles/App.scss';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import { AppConfiguration } from './core/types';
import { initViewStates, viewLoaded } from './core/views';
import { finishInitialization, initApplicationConfiguration } from './core/app-cfg';
import { initGlobalsOnWindow } from './features/globals';
import { initCloudState } from './features/cloudstorage/cloud';
import { loadDomainConfigurations } from './core/domain';
import { loadData } from './core/project/projectdata';
import { initUserStats } from './features/stats';
import { useState, useEffect } from 'react';
import { APP_CONTEXT, contextStore, getAppInstance, instanceInitializationBlocked, setAppInstance, setAppInstanceInitialized } from './appContext';
import { InitializingView } from './views/InitializingView';
import { AppView } from './AppView';

library.add(fas, far);
// some envs complain about IconPack typing; cast to any to add full brands pack
library.add(fab as any);
library.add(far);

interface AppProps {
  configuration: AppConfiguration;
  id?: string;
}

function App(props: AppProps) {
  const [appInstanceId] = useState<string | null>(props.id);
  const [appContext] = contextStore.useState(APP_CONTEXT);   
  const [instanceInitialized, setInstanceInitialized] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  
  useEffect(() => {
    initializeApp();
  }, []);  

  const initializeApp = async () => {
    if (instanceInitializationBlocked(props.id)) return;
    await initApp(props.configuration, props.id);
    setInstanceInitialized(true);
    await loadAppData();
    setDataLoaded(true);
    setAppInstanceInitialized(props.id);
  };

  function activateApp() {
    console.log('App:'+appInstanceId+' Activating Instance. Old instance: ' + getAppInstance());
    setAppInstance(appInstanceId);
  }

  const isActiveInstance = (appInstanceId === appContext.instanceId);

  if (!appInstanceId || !instanceInitialized) {        
    return (
      <InitializingView viewInactive={!appInstanceId} viewInitialized={!instanceInitialized} activateApp={initializeApp} />
    ); 
  }

  return (
    <div className="App sandkasten">      
      {isActiveInstance ? (
        <AppView />
      ) : (
        <InitializingView viewInactive={!appInstanceId} viewInitialized={!instanceInitialized} activateApp={initializeApp} />
      )}
    </div>
  );
}

export async function initApp(cfg: AppConfiguration, instanceId: string) {
  if (cfg.initialized) return;
  initApplicationConfiguration(cfg, instanceId);
  initViewStates();
  await initApplicationState(instanceId);
  initGlobalsOnWindow(instanceId);  
}

async function initApplicationState(instanceId : string) : Promise<void> {
  initCloudState();  
  await loadDomainConfigurations();  
  finishInitialization(instanceId);  
}

async function loadAppData() : Promise<void> {
  initUserStats();
  await loadData(false);
  viewLoaded();  
}

export default App;